import type { SVGProps } from 'react';
const DawnFlagFM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-FM_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-FM_svg__a)">
      <path fill="#95CEF5" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M9.768 5.46 11 4.607l1.231.851-.414-1.455 1.175-.93-1.488-.048L11 1.6l-.505 1.426-1.488.048 1.176.93zm0 8.533L11 13.14l1.231.852-.414-1.456 1.175-.93-1.488-.048L11 10.133l-.505 1.426-1.488.049 1.176.93zm5.422-5.118-1.231.851.414-1.456-1.176-.93 1.488-.048.505-1.425.505 1.425 1.488.049-1.176.93.415 1.455zm-9.612.851 1.231-.851 1.232.851-.415-1.456 1.176-.93-1.488-.048-.505-1.425-.505 1.425-1.488.049 1.176.93z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagFM;
